import React from 'react';

import { useIntl } from 'react-intl';

import { OptInLabel, TermsLink } from '../styled';

export const PromotionalEmailsLabel = () => {
  const { formatMessage } = useIntl();

  return (
    <OptInLabel data-testid="opt-in-label-acceptEmailsAndSpecialOffers">
      {formatMessage({ id: 'acceptEmailsAndSpecialOffers.th' })}
    </OptInLabel>
  );
};

export const TermsOfServiceLabel = () => {
  const { formatMessage } = useIntl();

  const privacyPolicyLink = (
    <TermsLink to={formatMessage({ id: 'routes.privacyPolicy' })}>
      {formatMessage({ id: 'privacyPolicySignUpPage' })}
    </TermsLink>
  );
  const termsOfServiceLink = (
    <TermsLink to={formatMessage({ id: 'routes.termsOfService' })}>
      {formatMessage({ id: 'termsOfServiceSignUpPage' })}
    </TermsLink>
  );
  const rewardsPolicyLink = (
    <TermsLink to={formatMessage({ id: 'routes.timsRewardsTermsAndConditions' })}>
      {formatMessage({ id: 'timsRewardsTermsAndConditionsSignUpPage' })}
    </TermsLink>
  );

  return (
    <OptInLabel>
      {formatMessage(
        { id: 'acceptTermsAndPrivacyIntro' },
        { privacyPolicyLink, rewardsPolicyLink, termsOfServiceLink }
      )}
    </OptInLabel>
  );
};
